// Import des images utilisées dans les news ........................................
import imgbanner1 from "../../../assets/img/img-banniere/01-TCF-Terrains-exterieurs-4000x1440.jpg";
import imgbanner2 from "../../../assets/img/img-banniere/02-TCF-Terrains-exterieurs-4000x1440.jpg";
import imgbanner3 from "../../../assets/img/img-banniere/03-TCF-Clubhouse-4000x1800.jpg";
import imgbanner4 from "../../../assets/img/img-banniere/04-TCF-Terrains-couverts-4000x1800.jpg";

const tableBanner = [
  {
    id: 1,
    image: imgbanner1,
    title: "Découvrez nos courts extérieurs",
    description: "-",
    buttonText: "",
    buttonLink: "/#",
  },
  {
    id: 2,
    image: imgbanner2,
    title: "Découvrez nos courts extérieurs",
    description: "-",
    buttonText: "",
    buttonLink: "/#",
  },
  {
    id: 3,
    image: imgbanner3,
    title: "Un clubhouse pour tous les membres",
    description: "-",
    buttonText: "",
    buttonLink: "/#",
  },
  {
    id: 4,
    image: imgbanner4,
    title: "Découvrez nos courts couverts",
    description: "-",
    buttonText: "",
    buttonLink: "/#",
  },
];

export default tableBanner;
